module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"productColName":"Product","noRows":"No data is available with the current constraints, please either complete the filters or select others."},"es":{"productColName":"Producto","noRows":"No hay datos disponibles para los filtros seleccionados, por favor, termina de seleccionar los filtros o cambia la selección de los mismos."}}')
  delete Component.options._Ctor
}
